/* Belle's Secrets — generic scroll-snap carousel controller
   Markup: [data-bs-carousel] > [data-bs-carousel-track] (.bs-scroller) + optional
           [data-bs-carousel-prev] / [data-bs-carousel-next] / [data-bs-carousel-dot] */
(function () {
  function init(root) {
    if (root.dataset.bsCarouselReady) return;
    root.dataset.bsCarouselReady = '1';
    var track = root.querySelector('[data-bs-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-bs-carousel-prev]');
    var next = root.querySelector('[data-bs-carousel-next]');
    var dots = root.querySelectorAll('[data-bs-carousel-dot]');

    function step() {
      var first = track.querySelector(':scope > *');
      if (!first) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      root.classList.toggle('bs-carousel--static', (track.scrollWidth - track.clientWidth) <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots.length) {
        var idx = Math.round(track.scrollLeft / step());
        dots.forEach(function (d, i) { d.toggleAttribute('aria-current', i === idx); });
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { track.scrollTo({ left: step() * i, behavior: 'smooth' }); });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot() { document.querySelectorAll('[data-bs-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
